"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDropdown = void 0;
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var useDropdown = function (_a) {
    var options = _a.options, onChange = _a.onChange, value = _a.value;
    var t = (0, next_intl_1.useTranslations)();
    var _b = (0, react_1.useState)(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = (0, react_1.useState)(null), selectedValue = _c[0], setSelectedValue = _c[1];
    (0, react_1.useEffect)(function () {
        if (value === undefined) {
            setSelectedValue(null);
        }
    }, [value]);
    var _d = (0, react_1.useState)(''), search = _d[0], setSearch = _d[1];
    var optionsWithALl = (0, react_1.useMemo)(function () { return __spreadArray([{ id: 'all', title: t('all') }], options, true); }, [t, options]);
    var handleOnChange = (0, react_1.useCallback)(function (id) {
        setSelectedValue(id);
    }, []);
    var openDropdown = (0, react_1.useCallback)(function () { return setIsOpen(!isOpen); }, [setIsOpen, isOpen]);
    var closeDropdown = (0, react_1.useCallback)(function () {
        if (isOpen) {
            if (selectedValue === 'all')
                onChange(undefined);
            else
                onChange(selectedValue);
            setIsOpen(false);
        }
    }, [isOpen, setIsOpen, onChange, selectedValue]);
    var filteredOptions = (0, react_1.useMemo)(function () {
        return optionsWithALl.filter(function (o) {
            var _a, _b, _c;
            if (search && search !== '') {
                var title = (_a = o === null || o === void 0 ? void 0 : o.title) === null || _a === void 0 ? void 0 : _a.toLowerCase();
                if (title === 'all')
                    return false;
                return title === null || title === void 0 ? void 0 : title.startsWith(search === null || search === void 0 ? void 0 : search.toLowerCase());
            }
            return (_c = (_b = o === null || o === void 0 ? void 0 : o.title) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === null || _c === void 0 ? void 0 : _c.startsWith(search === null || search === void 0 ? void 0 : search.toLowerCase());
        });
    }, [optionsWithALl, search]);
    var findFirstOptionFromSearch = (0, react_1.useCallback)(function (search) {
        return filteredOptions.find(function (o) {
            var _a;
            var title = (_a = o === null || o === void 0 ? void 0 : o.title) === null || _a === void 0 ? void 0 : _a.toLowerCase();
            return title === null || title === void 0 ? void 0 : title.startsWith(search === null || search === void 0 ? void 0 : search.toLowerCase());
        });
    }, [filteredOptions]);
    var resetFilters = (0, react_1.useCallback)(function () {
        setSearch('');
        setSelectedValue(null);
        setIsOpen(false);
        onChange(undefined);
    }, [setSearch, setSelectedValue, onChange, setIsOpen]);
    return (0, react_1.useMemo)(function () { return ({
        search: search,
        setSearch: setSearch,
        setSelectedValue: setSelectedValue,
        filteredOptions: filteredOptions,
        selectedValue: selectedValue,
        handleOnChange: handleOnChange,
        openDropdown: openDropdown,
        closeDropdown: closeDropdown,
        isOpen: isOpen,
        findFirstOptionFromSearch: findFirstOptionFromSearch,
        resetFilters: resetFilters,
    }); }, [
        search,
        setSearch,
        setSelectedValue,
        filteredOptions,
        selectedValue,
        handleOnChange,
        isOpen,
        closeDropdown,
        openDropdown,
        findFirstOptionFromSearch,
        resetFilters,
    ]);
};
exports.useDropdown = useDropdown;
